import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppApiNotificationConfigMode } from '../types/app-api-notification-config-mode.type';
import { DialogService, DialogStatus } from './dialog.service';

export interface ApiNotificationConfig {
  result?: any; // MyResult; TODO torbatian
  mode?: AppApiNotificationConfigMode;
  /** The length of time in milliseconds to wait before automatically dismissing */
  duration?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ApiNotificationService {
  constructor(
    private dialogService: DialogService,
    private translateService: TranslateService
  ) {}

  notifyMessage(config: ApiNotificationConfig) {
    //default value
    if (!config.mode) config.mode = 'openSnackBarDialog';
    config.duration = 10000;

    if (config.result.isSucceed) this.notifySuccess(config);
    else this.notifyError(config);
  }

  notifySuccess(config: ApiNotificationConfig) {
    const Msg = config.result?.message.replace(/;/g, '<br>');
    const Title = this.translateService.instant('messages.successfulOperation');

    //open snackBarDialog
    if (config.mode == 'openSnackBarDialog')
      this.dialogService.openSnackBarDialog({
        message: `${Msg}`,
        duration: config?.duration,
      });
    //open matDialog
    else if (config.mode == 'matDialog')
      this.dialogService.openDialog({
        title: Title,
        message: `${Msg}`,
        status: DialogStatus.success,
        duration: config?.duration,
      });
  }

  notifyError(config: ApiNotificationConfig) {
    const Msg = config.result?.detail.replace(/;/g, '<br>');
    const Type = config.result.type;
    const Title = this.translateService.instant('messages.failedOperation', {
      operation: Type,
    });

    //open matDialog
    this.dialogService.openDialog({
      title: Title,
      message: Msg,
      status: DialogStatus.error,
      duration: config?.duration,
    });
  }
}
